import { ScoreType } from './constants';

export const getPatientScoreResult = (patientScore) => {
  let result = '-';

  if (patientScore.strResult) {
    result = patientScore.strResult;
  }

  if (typeof patientScore.boolResult === 'boolean') {
    result = patientScore.boolResult ? 'Yes' : 'No';
  }

  if (typeof patientScore.intResult === 'number') {
    result = `${patientScore.intResult}`;

    if (patientScore.maxIntResult) {
      result += `/${patientScore.maxIntResult}`;
    }
  }

  return result;
};

export const getPatientScoreValue = (patientScore) => {
  if (patientScore.strResult) return patientScore.strResult;
  if (typeof patientScore.boolResult === 'boolean') return patientScore.boolResult;
  if (typeof patientScore.intResult === 'number') return patientScore.intResult;

  return null;
};

export const getPatientScoreType = (scoreType) =>
  Object.values(ScoreType).find((ps) => ps.value === scoreType)?.label ?? '';
